/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import * as API from "../../framework/API/api";
import { FILEURL, ENTITYNAME, MILLISECONDSINADAY, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { utility } from "../../framework/utility/utilityProvider";
import ProgressBarPopup from "../../framework/forms/helpercomponents/ProgressBarPopup";
import ToastNotification from "../../components/ToastNotification";


export const MissingMediaReport = () => {

    const blankDataItem = {
        ModuleType: {},
        startDate: "",
        endDate: "",
        // ReportType: REPORTTYPE[0]
    }

    const navigate = useNavigate();
    const lang = useTranslation();

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channel, setChannel] = useState([]);

    const payloadRef = useRef({});
    const selectedChannelRef = useRef();
    const setSelectedChannelRef = (data) => {
        selectedChannelRef.current = data;
    }

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannel(channelRes.data);
    }

    const isValid = () => {

        if (!dataItem.Channel || Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }

        if (!dataItem.startDate || dataItem.startDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_from_date_error_message });
            return false;
        }

        if (!dataItem.endDate || dataItem.endDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_to_date_error_message });
            return false;
        }

        if (dataItem.endDate < dataItem.startDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.to_date_should_not_be_less_than_from_date_error_message });
            return false;
        }

        const start = new Date(dataItem.startDate);
        const end = new Date(dataItem.endDate);

        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const diffInMs = end - start;
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        const endOfMonthDays = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();

        if (diffInDays > endOfMonthDays) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.from_date_to_date_should_not_be_more_than_days_error_message} ${endOfMonthDays} Days` });
            return false;
        }

        return true;
    }

    const exportData = async () => {
        if (!isValid()) return;
        payloadRef.current = {
            ScheduleDate: dataItem?.startDate ? utility.convertStringDatetoMilliseconds(dataItem?.startDate) : 0,
            ScheduleEndDate: dataItem?.endDate ? utility.convertStringDatetoMilliseconds(dataItem?.endDate) + MILLISECONDSINADAY - 1000 : 0,
            channelSID: selectedChannelRef?.current?.SID,
            isExport: true
        }
        exportReport();
    }

    const exportReport = async () => {
        let res = await API.getScheduleMAMAssetMediaReport(payloadRef.current);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Successfully Exported!' });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    const onChange = async (e) => {
        if (e.target.name == 'Channel') {
            setSelectedChannelRef(e.target.value)
        }
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    return (<>
        <BossDialog title={lang.missing_media_report_dialog_header} onClose={() => navigate('/home')} width={"650px"}>
            <div className="row">
                <div className="col-12 form-group">
                    <label htmlFor="TabView">{lang.channel_label} *</label>
                    <DropDownList
                        data={channel}
                        name={"Channel"}
                        textField="FullChannelName"
                        dataItemKey="_id"
                        value={dataItem.Channel}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <label htmlFor="TabView">{lang.from_date_label} *</label>
                    <input
                        className="form-control form-control-sm"
                        type="date"
                        name="startDate"
                        value={dataItem.startDate}
                        onChange={onChange}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.to_date_label} *</label>
                    <input
                        className="form-control form-control-sm"
                        type="date"
                        name="endDate"
                        value={dataItem.endDate}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12 form-group">
                    <ActionButton title={lang.export_button_tooltip} name={lang.export_button_text} onClick={exportData} style={{ margin: '0px', borderRadius: '5px' }} />
                </div>
            </div>
            <ProgressBarPopup ModuleID={MODULE.MISSINGMEDIAREPORT} />

        </BossDialog>
    </>)
}
export default MissingMediaReport;